import React, { useEffect } from "react";
import { Result, Button } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

export const Info = () => {
  useEffect(() => {
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 pt-16 flex items-center justify-center px-4">
      <Result
        icon={<SmileOutlined />}
        title="Təbriklər! Hesabınızı uğurla aktivləşdirdiniz"
        extra={
          <Link to="/">
            <Button type="primary">Əsas səhifəyə qayıt</Button>
          </Link>
        }
      />
    </div>
  );
};
